module.exports = __webpack_public_path__ + "img/programme5.0796e431.png";